import React from 'react';
import { ContentFrame, LayoutContent, ScreenContainer, } from '@pinwheel/origami';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
export var ScreenLoadingSkeleton = function () {
    return (React.createElement(ScreenContainer, null,
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, null,
                React.createElement("div", { "aria-busy": true, style: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        paddingTop: '60px',
                        flexDirection: 'column',
                    } },
                    React.createElement(Skeleton, { height: 50, style: { marginBottom: '20px' } }),
                    React.createElement(Skeleton, { height: 50, style: { marginBottom: '20px' } }),
                    React.createElement(Skeleton, { height: 50, style: { marginBottom: '20px' } }))))));
};
